import React, { useState } from "react";
import { LivestreamLayoutCommonProps } from "../../../types";
import LayoutModal from "../../event-card/FullScreenModal";
import { LayoutHeader } from "../../layouts/LayoutHeader";
import { Collection } from "@aws-amplify/ui-react";
import { EventCard } from "../../event-card";
import { FilterOption } from "../ToggleFilter/ToggleFilter";
import { filterEventsByType } from "../../../libs/utils/eventFilter";
import { EmptyLiveStreams } from "../../empty-state";

export const Layout1: React.FC<LivestreamLayoutCommonProps> = ({
    events,
    sessionToken,
    isSignedIn,
    activePlans,
    hasFullAccess,
    freeTrialPlanIds,
    onWatchClick
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState<FilterOption>('All');

    const handleSeeAllClick = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const filteredEvents = filterEventsByType(events, selectedOption);

    if (!events.length) return <EmptyLiveStreams />;

    return (
        <>
            <LayoutHeader
                title={'Live Streams'}
                itemCount={filteredEvents?.length}
                selectedOption={selectedOption}
                setSelectedOption={setSelectedOption}
                onSeeAll={handleSeeAllClick}
                padding="20px 10px 20px 0px"
                marginTop="0px"
                showToggle={true}
                isLivestream={true}
            />
            {filteredEvents.length === 0 ? (
                <EmptyLiveStreams showHeader={false} isFiltered={selectedOption !== 'All'} />
            ) : (
                <Collection
                    items={filteredEvents}
                    type="grid"
                    templateColumns={
                        "repeat(auto-fill, minmax(max(240px, 25% - 0.75rem), 1fr))"
                    }
                    templateRows={"auto"}
                    gap={"var(--grid-container-gap)"}
                    autoFlow={"dense"}
                    isPaginated={false}
                    alignContent={"center"}
                >
                    {(item: any, index: number) => (
                        <EventCard
                            event={item}
                            isSignedIn={isSignedIn}
                            hasEligiblePlan={
                                isSignedIn &&
                                (!!item.planDetails.length
                                    ? !!activePlans.filter((memberPlan) =>
                                        item.planDetails?.some(
                                            (itemPlan: any) =>
                                                itemPlan?.id === memberPlan.id
                                        )
                                    ).length ||
                                    freeTrialPlanIds.includes(
                                        item.planDetails[0]?.id
                                    ) ||
                                    hasFullAccess
                                    : true)
                            }
                            onWatchClick={onWatchClick}
                            key={item.id}
                        />
                    )}
                </Collection>
            )}

            {/* Modal with Lazy Loaded Cards */}
            <LayoutModal
                show={isModalOpen}
                onHide={handleCloseModal}
                filteredLiveEvents={events}
                isSignedIn={isSignedIn}
                activePlans={activePlans}
                hasFullAccess={hasFullAccess}
                freeTrialPlanIds={freeTrialPlanIds}
                onWatchClick={onWatchClick}
            />
        </>
    );
};
